import ReferentielApi from '@/api/referentiel';
import StoreBuilder from '../store-builder';

const builder = new StoreBuilder('referentiel');
builder.addStatePart('referentiel', null, (numTiers) => ReferentielApi.getReferentiel(numTiers));
builder.addStatePart('paramsCommande', null, ({ numTiers, numArticle, numLot }) => ReferentielApi.getParametresCommande(numArticle, numTiers, numLot));

export default builder.build();
